import { useEffect, useRef, useState } from "react";
import MenuLayout from "../../layouts/MenuLayout";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  fetchBootCamps,
  fetchNuterras,
  fetchWebinarData,
  getAllPublicWorkshop,
} from "../../redux/features/coach/actions/authAction";
import Loader from "../../components/loader";
import { coachPaths } from "../../routes/coach";
import ClaimYourSpot from "../../components/pages/coach/webinar/claim-your-spot";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import WaittingListBootCamp from "../../components/Modals/purchaseModal/WaittingListBootCamp";
import PaymentModal from "../../components/Modals/common/webinar/PaymentModal";
import BootcampPurchaseModal from "../../components/Modals/purchaseModal/bootcampPurchaseModal";
import NoRecord from "../../components/form/NoRecord";
import { enterPrisesPaths } from "../../routes/enterprises";
import { pipViewDate } from "../../utils/pip";

const WebinarData = () => {
  const { isLoading, allWebinarList, bootcampList, workshopList, nuterraList } =
    useSelector((state) => state.coach.auth);
  const [isSpotModal, setIsSpotModal] = useState(false);
  const [isSuccessModal, setIsSuccessModal] = useState(true);
  const [id, setId] = useState("");
  const { state } = useLocation();

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const [isWorkShop, setIsWorkShop] = useState(state?.data || "webinar");
  const byPopularityList = {
    webinar: allWebinarList,
    workshop: workshopList,
    bootCamp: bootcampList,
    nuterra: nuterraList,
  };

  const [isPurchse, setIsPurchase] = useState(false);
  const [isWaitList, setIsWaitList] = useState(false);
  const [bootCampId, setBootCampId] = useState("");
  const [isPaymentShow, setIsPaymentShow] = useState(false);

  const dispath = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setIsWorkShop(state?.data || "webinar");
  }, [state?.data]);

  useEffect(() => {
    dispath(fetchWebinarData());
    dispath(fetchNuterras());
    dispath(getAllPublicWorkshop());
    dispath(fetchBootCamps());
  }, []);

  const formatToCET = (utcDateString) => {
    if (!utcDateString) return;
    const date = new Date(utcDateString);
    const formatter = new Intl.DateTimeFormat("en-GB", {
      weekday: "long",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
      timeZone: "Europe/Paris",
    });
    const formattedDate = formatter.format(date);
    const cleaned = formattedDate
      .replace(",", "")
      .replace(",", "")
      .replace(/(\d{1,2})$/, "$1.")
      .trim();
    return `${cleaned} CET`;
  };

  const handleModalOpen = (item) => {
    setBootCampId(item?.bootcamp_id);
    if (item?.available_seats == 0) {
      setIsWaitList(true);
    } else {
      setIsPurchase(true);
    }
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <MenuLayout isWorkShop={isWorkShop}>
        <section class="ct_workshop_banner ct_px_40 py-4">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div
                class="col-lg-7 mb-4 mb-lg-0"
                data-aos="fade-right"
                data-aos-duration="3000"
              >
                <h2
                  class="ct_fs_50_new mb-4 ct_darkblue_text"
                  style={{ maxWidth: "527px" }}
                >
                  Events That <span class="ct_yellow_text">Move</span> You
                  Forward
                </h2>
                <p
                  class="mb-0 ct_fs_20 ct_darkblue_text"
                  style={{ maxWidth: "565px" }}
                >
                  Join live, expert-led sessions designed to spark clarity,
                  sharpen your strategy, and help you take real action — whether
                  you're a founder, leader, or team member.
                </p>
                <div class="mt-4 pt-2">
                  <a class="ct_yellow_btn px-5 ct_fit_content">
                    Unlock Your Path
                  </a>
                </div>
              </div>
              <div
                class="col-lg-5 mb-4 mb-lg-0"
                data-aos="fade-left"
                data-aos-duration="1000"
              >
                <div class="ct_workshop_right_img">
                  <img
                    src="assets/img/workshp_right_img.png"
                    alt=""
                    style={{ maxWidth: "100%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="ct_coach_created_bg ct_px_40">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12 text-center">
                <h4 class="ct_fs_32 mb-4 ct_darkblue_text">
                  Find an Event That Fits You
                </h4>
                <p class="mb-0 ct_fs_20 ct_darkblue_text">
                  Browse our network of expert coaches by type, focus, or
                  availability
                </p>
              </div>
            </div>
            <div class="row mt-5">
              <div
                class="col-lg-3 mb-4 mb-md-0"
                data-aos="fade-down"
                data-aos-duration="1000"
              >
                <div class="ct_filter_sidebar ct_custom_scroll">
                  <div class="ct_close_filter d-block d-lg-none">
                    <i class="fa-solid fa-xmark"></i>
                  </div>
                  <div class="d-flex align-items-center gap-2">
                    <label class="toggle-switch">
                      <input type="checkbox" />
                      <div class="toggle-switch-background">
                        <div class="toggle-switch-handle"></div>
                      </div>
                    </label>
                    Create Alert
                  </div>
                  <div class="mt-4">
                    <h5 class="ct_fs_16 ct_fw_600 mb-3">By Time & Date</h5>
                    <ul>
                      <li>
                        <div class="ct_radio-wrapper">
                          <label class="ct_radio-button">
                            <input
                              id="option1"
                              name="ct_radio-group"
                              type="radio"
                            />
                            <span class="ct_radio-checkmark"></span>
                          </label>
                          <p class="mb-0">Upcoming</p>
                        </div>
                      </li>
                      <li class="mt-2">
                        <div class="ct_radio-wrapper">
                          <label class="ct_radio-button">
                            <input
                              id="option1"
                              name="ct_radio-group"
                              type="radio"
                            />
                            <span class="ct_radio-checkmark"></span>
                          </label>
                          <p class="mb-0">Newest added </p>
                        </div>
                      </li>
                      <li class="mt-2">
                        <div class="ct_radio-wrapper">
                          <label class="ct_radio-button">
                            <input
                              id="option1"
                              name="ct_radio-group"
                              type="radio"
                            />
                            <span class="ct_radio-checkmark"></span>
                          </label>
                          <p class="mb-0">Pasted workshops </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="mt-4">
                    <h5 class="ct_fs_16 ct_fw_600 mb-3">By organiser </h5>
                    <ul>
                      <li>
                        <div class="ct_radio-wrapper">
                          <label class="ct_radio-button">
                            <input
                              id="option1"
                              name="ct_radio-group"
                              type="radio"
                            />
                            <span class="ct_radio-checkmark"></span>
                          </label>
                          <p class="mb-0">NUVIO</p>
                        </div>
                      </li>
                      <li class="mt-2">
                        <div class="ct_radio-wrapper">
                          <label class="ct_radio-button">
                            <input
                              id="option1"
                              name="ct_radio-group"
                              type="radio"
                            />
                            <span class="ct_radio-checkmark"></span>
                          </label>
                          <p class="mb-0">Coaches</p>
                        </div>
                      </li>
                      <li class="mt-2">
                        <div class="ct_radio-wrapper">
                          <label class="ct_radio-button">
                            <input
                              id="option1"
                              name="ct_radio-group"
                              type="radio"
                            />
                            <span class="ct_radio-checkmark"></span>
                          </label>
                          <p class="mb-0">Enterprises </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="mt-4">
                    <h5 class="ct_fs_16 ct_fw_600 mb-3">By popularity</h5>
                    <ul>
                      <li>
                        <div class="form-check ct_custom_check2 d-flex align-items-center gap-2">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="flexCheckDefault"
                            onClick={() => setIsWorkShop("webinar")}
                            checked={isWorkShop == "webinar"}
                          />
                          <label>Webinars</label>
                        </div>
                      </li>
                      <li class="mt-2">
                        <div class="form-check ct_custom_check2 d-flex align-items-center gap-2">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            onClick={() => setIsWorkShop("bootCamp")}
                            checked={isWorkShop == "bootCamp"}
                          />
                          <label>Bootcamps</label>
                        </div>
                      </li>
                      <li class="mt-2">
                        <div class="form-check ct_custom_check2 d-flex align-items-center gap-2">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="flexCheckDefault"
                            onClick={() => setIsWorkShop("workshop")}
                            checked={isWorkShop == "workshop"}
                          />
                          <label>Workshops</label>
                        </div>
                      </li>
                      <li class="mt-2">
                        <div class="form-check ct_custom_check2 d-flex align-items-center gap-2">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="flexCheckDefault"
                            onClick={() => setIsWorkShop("nuterra")}
                            checked={isWorkShop == "nuterra"}
                          />
                          <label>NuTerra</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="mt-4">
                    <h5 class="ct_fs_16 ct_fw_600 mb-3">
                      Coaching Categories{" "}
                    </h5>
                    <ul>
                      <li>
                        <div class="form-check ct_custom_check2 d-flex align-items-center gap-2">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="">Founder</label>
                        </div>
                      </li>
                      <li class="mt-2">
                        <div class="form-check ct_custom_check2 d-flex align-items-center gap-2">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="">Leadership</label>
                        </div>
                      </li>
                      <li class="mt-2">
                        <div class="form-check ct_custom_check2 d-flex align-items-center gap-2">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="">Team</label>
                        </div>
                      </li>
                      <li class="mt-2">
                        <div class="form-check ct_custom_check2 d-flex align-items-center gap-2">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="">Performance</label>
                        </div>
                      </li>
                      <li class="mt-2">
                        <div class="form-check ct_custom_check2 d-flex align-items-center gap-2">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="">Business</label>
                        </div>
                      </li>
                      <li class="mt-2">
                        <div class="form-check ct_custom_check2 d-flex align-items-center gap-2">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label for="">Personal</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="mt-4">
                    <div class="form-group">
                      <label class="mb-2 ct_fw_600">Search</label>
                      <div class="ct_search">
                        <input
                          type="text"
                          class="form-control ct_input"
                          placeholder="Search"
                        />
                        <i class="fa-solid fa-magnifying-glass ct_left_icon_search"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-lg-9 ct_ps_lg_80 mb-4 mb-md-0"
                data-aos="fade-down"
                data-aos-duration="1000"
              >
                <div class="ct_filter_btn d-flex d-lg-none justify-content-end mb-4">
                  <button class="ct_outline_grey ct_yellow_btn ct_h_35 d-flex align-items-center gap-2">
                    Filter{" "}
                    <img src="../assets/img/octicon_filter-16.png" alt="" />
                  </button>
                </div>
                <div class="row">
                  {isWorkShop == "workshop" &&
                    workshopList?.length != 0 &&
                    workshopList?.map((item) => (
                      <div class="col-md-6 mb-5">
                        <figure class="mb-0 ct_coach_created_card d-grid ct_border_radius_20 bg-white">
                          <div>
                            <div
                              class="ct_coach_created_img ct_img_330 ct_cursor_pointer ct_ratio_unset123"
                              onClick={() =>
                                navigate(
                                  `${coachPaths?.CoachWork_shopDetail}?workshop_id=${item?.workshop_id}`,
                                  {
                                    state: { data: item },
                                  },
                                )
                              }
                            >
                              <img
                                src={item?.image2 ?? "assets/img/Event_1_1.png"}
                                alt=""
                                style={{
                                  objectFit: "contain",
                                  backgroundColor: "#f5f5f5",
                                }}
                              />
                            </div>
                            <figcaption class="mt-3 px-3 pb-3 ct_cursor_pointer">
                              <div
                                class="d-lg-flex align-items-start gap-2 justify-content-between mb-2"
                                onClick={() =>
                                  navigate(
                                    `${coachPaths?.CoachWork_shopDetail}?workshop_id=${item?.workshop_id}`,
                                    {
                                      state: { data: item },
                                    },
                                  )
                                }
                              >
                                <p class="mb-0 ct_fs_18 ct_para_scroll ct_custom_scroll">
                                  {item?.section_1?.title ?? ""}
                                </p>
                                <p
                                  class="mb-0 ct_fs_14 ct_text_op_8"
                                  style={{ maxWidth: "100px" }}
                                >
                                  {formatToCET(item?.schedule_date)}
                                </p>
                              </div>
                            </figcaption>
                          </div>
                          <p
                            class="mt-auto mb-2 px-3  ct_fs_16 ct_cursor_pointer"
                            onClick={() =>
                              navigate(
                                `${coachPaths?.CoachWork_shopDetail}?workshop_id=${item?.workshop_id}`,
                                {
                                  state: { data: item },
                                },
                              )
                            }
                          >
                            By {item?.created_user_name ?? ""}{" "}
                            {item?.create_role &&
                              `/ ${item?.create_role} Coach`}
                          </p>
                        </figure>
                      </div>
                    ))}
                  {isWorkShop == "webinar" &&
                    allWebinarList?.length != 0 &&
                    allWebinarList?.map((item) => (
                      <div class="col-md-6 mb-5">
                        <figure class="mb-0 ct_coach_created_card ct_border_radius_20 bg-white">
                          <div
                            class="ct_coach_created_img ct_img_330 ct_cursor_pointer ct_ratio_unset123"
                            onClick={() =>
                              navigate(
                                `${coachPaths?.WebinarDataDetails}?webinar_id=${item?.webinar_id}`,
                                {
                                  state: { data: item },
                                },
                              )
                            }
                          >
                            <img
                              src="assets/img/Event_1_1.png"
                              alt=""
                              style={{
                                objectFit: "contain",
                                backgroundColor: "#f5f5f5",
                              }}
                            />
                          </div>
                          <figcaption class="mt-3 px-3 pb-3 ct_cursor_pointer">
                            <div
                              class="d-flex align-items-center gap-2 justify-content-between mb-2"
                              onClick={() =>
                                navigate(
                                  `${coachPaths?.WebinarDataDetails}?webinar_id=${item?.webinar_id}`,
                                  {
                                    state: { data: item },
                                  },
                                )
                              }
                            >
                              <p class="mb-0 ct_fs_18">
                                {item?.section_1?.title ?? ""}
                              </p>
                              <p class="mb-0 ct_fs_14 ct_text_op_8">
                                {formatToCET(item?.schedule_date)}
                              </p>
                            </div>
                            <ul
                              className="ct_cursor_pointer"
                              onClick={() =>
                                navigate(
                                  `${coachPaths?.WebinarDataDetails}?webinar_id=${item?.webinar_id}`,
                                  {
                                    state: { data: item },
                                  },
                                )
                              }
                            >
                              {item?.section_4?.cards?.length != 0 &&
                                item?.section_4?.cards?.map((items) => (
                                  <li class="ct_fs_14 mb-1">
                                    <i class="fa-solid fa-circle-check me-2"></i>
                                    {items?.description ?? ""}
                                  </li>
                                ))}
                            </ul>
                            <p
                              class="ct_fs_14 mb-0 mt-2"
                              onClick={() =>
                                navigate(
                                  `${coachPaths?.WebinarDataDetails}?webinar_id=${item?.webinar_id}`,
                                  {
                                    state: { data: item },
                                  },
                                )
                              }
                            >
                              {" "}
                              Live on Zoom.{" "}
                              {item?.section_5?.cards?.length != 0 &&
                                item?.section_5?.cards[0]?.text_2}
                              . Q&A included
                            </p>
                            <div class="mt-3">
                              <a
                                onClick={() => {
                                  setIsSpotModal(true);
                                  setId(item?.webinar_id);
                                }}
                                class="ct_hover_link_orange ct_fs_14"
                                style={{ color: "#219EBC" }}
                              >
                                Register Now{" "}
                                <i class="fa-solid fa-arrow-right"></i>
                              </a>
                            </div>
                          </figcaption>
                        </figure>
                      </div>
                    ))}
                  {isWorkShop == "bootCamp" &&
                    bootcampList?.length != 0 &&
                    bootcampList?.map((item) => (
                      <div class="col-md-6 mb-5">
                        <figure class="mb-0 ct_coach_created_card ct_border_radius_20 bg-white">
                          <div
                            class="ct_coach_created_img ct_img_330 ct_cursor_pointer ct_ratio_unset123"
                            onClick={() => {
                              navigate(
                                `/bootcamp-detail/${item?.bootcamp_id}`,
                                {
                                  state: {
                                    id: item?.bootcamp_id,
                                    data2: "landing",
                                    data: bootcampList,
                                  },
                                },
                              );
                            }}
                          >
                            <img
                              src={
                                item?.header_image ?? "assets/img/Event_1_1.png"
                              }
                              alt=""
                              style={{
                                objectFit: "contain",
                                backgroundColor: "#f5f5f5",
                              }}
                            />
                          </div>
                          <figcaption class="mt-3 px-3 pb-3 ct_cursor_pointer">
                            <div
                              class="d-flex align-items-center gap-2 justify-content-between mb-2"
                              onClick={() => {
                                navigate(
                                  `/bootcamp-detail/${item?.bootcamp_id}`,
                                  {
                                    state: {
                                      id: item?.bootcamp_id,
                                      data2: "landing",
                                      data: bootcampList,
                                    },
                                  },
                                );
                              }}
                            >
                              <p class="mb-0 ct_fs_18">
                                {item?.header_title ?? ""}
                              </p>
                              <p class="mb-0 ct_fs_14 ct_text_op_8">
                                {formatToCET(item?.start_date)}
                              </p>
                            </div>
                            <ul
                              className="ct_cursor_pointer"
                              onClick={() => {
                                navigate(
                                  `/bootcamp-detail/${item?.bootcamp_id}`,
                                  {
                                    state: {
                                      id: item?.bootcamp_id,
                                      data2: "landing",
                                      data: bootcampList,
                                    },
                                  },
                                );
                              }}
                            >
                              {item?.points?.length != 0 &&
                                item?.points?.map((items) => (
                                  <li class="ct_fs_14 mb-1">
                                    <i class="fa-solid fa-circle-check me-2"></i>
                                    {items ?? ""}
                                  </li>
                                ))}
                            </ul>
                            <p
                              class="ct_fs_14 mb-0 mt-2"
                              onClick={() => {
                                navigate(
                                  `/bootcamp-detail/${item?.bootcamp_id}`,
                                  {
                                    state: {
                                      id: item?.bootcamp_id,
                                      data2: "landing",
                                      data: bootcampList,
                                    },
                                  },
                                );
                              }}
                            >
                              {" "}
                              {item?.location ?? ""}
                            </p>
                            <div class="mt-3">
                              <a
                                // onClick={() => {
                                //   handleModalOpen(item);
                                // }}
                                onClick={() => {
                                  navigate(
                                    `/bootcamp-detail/${item?.bootcamp_id}`,
                                    {
                                      state: {
                                        id: item?.bootcamp_id,
                                        data2: "landing",
                                        data: bootcampList,
                                      },
                                    },
                                  );
                                }}
                                class="ct_hover_link_orange ct_fs_14"
                                style={{ color: "#219EBC" }}
                              >
                                View Details{" "}
                                <i class="fa-solid fa-arrow-right"></i>
                              </a>
                            </div>
                          </figcaption>
                        </figure>
                      </div>
                    ))}

                  {isWorkShop == "nuterra" &&
                    nuterraList?.length != 0 &&
                    nuterraList?.map((item) => (
                      <div class="col-md-6 mb-5">
                        <figure class="mb-0 ct_coach_created_card d-grid ct_border_radius_20 bg-white">
                          <div>
                            <div
                              class="ct_coach_created_img ct_img_330 ct_cursor_pointer ct_ratio_unset123"
                              onClick={() =>
                                navigate(
                                  `${coachPaths?.NuvioWellness}?wellness=${item?.nuterra_id}`,
                                  {
                                    state: { data: item },
                                  },
                                )
                              }
                            >
                              <img
                                src={
                                  item?.section1?.header_second_image ??
                                  "assets/img/Event_1_1.png"
                                }
                                alt=""
                                style={{
                                  objectFit: "contain",
                                  backgroundColor: "#f5f5f5",
                                }}
                              />
                            </div>
                            <figcaption class="mt-3 px-3 pb-3 ct_cursor_pointer">
                              <div
                                class="d-lg-flex align-items-start gap-2 justify-content-between mb-2"
                                onClick={() =>
                                  navigate(
                                    `${coachPaths?.NuvioWellness}?nuterra_id=${item?.nuterra_id}`,
                                    {
                                      state: { data: item },
                                    },
                                  )
                                }
                              >
                                <p class="mb-0 ct_fs_18 ct_para_scroll ct_custom_scroll">
                                  {item?.section1?.heading ?? ""}
                                </p>
                                <p
                                  class="mb-0 ct_fs_14 ct_text_op_8"
                                  style={{ maxWidth: "100px" }}
                                >
                                  {pipViewDate(item?.section1?.date) ?? ""}
                                </p>
                              </div>
                            </figcaption>
                          </div>
                          <p
                            class="mt-auto mb-2 px-3  ct_fs_16 ct_cursor_pointer"
                            onClick={() =>
                              navigate(
                                `${coachPaths?.NuvioWellness}?nuterra_id=${item?.nuterra_id}`,
                                {
                                  state: { data: item },
                                },
                              )
                            }
                          >
                            By Nuvio Team
                          </p>
                        </figure>
                      </div>
                    ))}

                  {!byPopularityList[isWorkShop]?.length && <NoRecord />}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="ct_pt_100 ct_px_40 ">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div
                class="col-lg-3 mb-4 mb-lg-0"
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                <div class="ct_how_work_img">
                  <img src="assets/img/how_owrks_556.png" alt="" />
                </div>
              </div>
              <div
                class="col-lg-9 mb-4 mb-lg-0 ps-lg-5"
                data-aos="fade-left"
                data-aos-duration="1000"
              >
                <div class="ct_how_work_content pb-3">
                  <h4 class="ct_fs_24 ct_darkblue_text">How It Works?</h4>
                  <h3 class="ct_fs_32 ct_darkblue_text">
                    Joining a live workshop is simple
                  </h3>
                </div>
                <div class="row mt-5">
                  <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                    <div class="ct_how_work_card">
                      <img
                        src="assets/img/ri_find-replace-fill.png"
                        alt=""
                        style={{ width: "40px", height: "40px" }}
                      />
                      <div className="mt-3">
                        <h4 class="ct_fs_20 mb-3 ct_darkblue_text">
                          Pick Your Workshop
                        </h4>
                        <p
                          class="mb-0 ct_darkblue_text"
                          style={{ maxWidth: "234px" }}
                        >
                          Browse upcoming sessions by topic, coach, or category.
                          Choose one that matches your current goals.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                    <div class="ct_how_work_card">
                      <img
                        src="assets/img/fa6-solid_handshake.png"
                        alt=""
                        style={{ width: "40px", height: "40px" }}
                      />
                      <div className="mt-3">
                        <h4 class="ct_fs_20 mb-3 ct_darkblue_text">
                          Save Your Spot
                        </h4>
                        <p
                          class="mb-0 ct_darkblue_text"
                          style={{ maxWidth: "234px" }}
                        >
                          Register in seconds some are free, some are paid, all
                          are packed with value.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                    <div class="ct_how_work_card">
                      <img
                        src="assets/img/uim_bag.png"
                        alt=""
                        style={{ width: "40px", height: "40px" }}
                      />
                      <div className="mt-3">
                        <h4 class="ct_fs_20 mb-3 ct_darkblue_text">
                          Join Live Learn
                        </h4>
                        <p
                          class="mb-0 ct_darkblue_text"
                          style={{ maxWidth: "234px" }}
                        >
                          Join your session via Zoom, engage with the coach, ask
                          questions, and leave with tools you can use.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          class="ct_looking_for_work_bg ct_mt_100 ct_dark_sky_bg ct_p_111_y_106"
          data-aos="fade-left"
          data-aos-duration="1000"
        >
          <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
            <div class="text-white">
              <h4 class="ct_fs_36 mb-4 " style={{ maxWidth: "500px" }}>
                Learn. Connect. Apply- All in one Session
              </h4>
              <p class="mb-0 ct_fs_18" style={{ maxWidth: "600px" }}>
                Get expert guidance, real-time feeedback,and practical tools you
                can start using immediately.
              </p>
            </div>
            <div class="ct_flex_shrink_0">
              <a class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5">
                Reserve Your Spot
              </a>
            </div>
          </div>
        </section>

        <section
          class="ct_mt_100 ct_story_light_bg ct_px_40"
          data-aos="fade-down"
          data-aos-duration="1000"
        >
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-4 mb-4 mb-lg-0">
                <div class="d-grid h-100 pt-2 pb-5">
                  <h2 class="ct_fs_40 ">
                    Real Stories, real{" "}
                    <span class="ct_yellow_text">success</span>
                  </h2>

                  <div class="ct_arrows mt-auto d-none d-lg-flex ">
                    <button className="ct_prev ct_arrow_btn" ref={prevRef}>
                      <i class="fa-solid fa-arrow-left"></i>
                    </button>
                    <button className="ct_next ct_arrow_btn" ref={nextRef}>
                      <i class="fa-solid fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-lg-8 mb-4 mb-lg-0">
                <Swiper
                  modules={[Navigation, Autoplay]}
                  spaceBetween={20}
                  slidesPerView={1}
                  loop={true}
                  autoplay={{ delay: 2500 }}
                  navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current,
                  }}
                  onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = prevRef.current;
                    swiper.params.navigation.nextEl = nextRef.current;
                  }}
                  className="ct_real_stories_slider"
                >
                  {/* Slide 1 */}
                  <SwiperSlide>
                    <div class="ct_story_slide_card">
                      <div class="ct_story_user_img">
                        <img src="assets/img/story_img_user.png" alt="" />
                      </div>
                      <div>
                        <div class="ct_orange_text mb-3">
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                        </div>
                        <h3 class="ct_fs_20 mb-3">
                          Climbing Higher with Every Project
                        </h3>
                        <p
                          class="ct_fS_18 ct_max_w_100_767"
                          style={{ maxWidth: "351px" }}
                        >
                          NuStar gave me access to exclusive projects that truly
                          challenged and grew my expertise. Today, I lead
                          innovative product initiatives and mentor upcoming
                          tech talents.
                        </p>
                        <div class="mt-5">
                          <h4 class="ct_fs_20">Chloe Adams</h4>
                          <p class="ct_fs_18">
                            Product Director at Zenith Tech
                          </p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div class="ct_story_slide_card">
                      <div class="ct_story_user_img">
                        <img src="assets/img/story_img_user.png" alt="" />
                      </div>
                      <div>
                        <div class="ct_orange_text mb-3">
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                        </div>
                        <h3 class="ct_fs_20 mb-3">
                          Climbing Higher with Every Project
                        </h3>
                        <p class="ct_fS_18" style={{ maxWidth: "351px" }}>
                          NuStar gave me access to exclusive projects that truly
                          challenged and grew my expertise. Today, I lead
                          innovative product initiatives and mentor upcoming
                          tech talents.
                        </p>
                        <div class="mt-5">
                          <h4 class="ct_fs_20">Chloe Adams</h4>
                          <p class="ct_fs_18">
                            Product Director at Zenith Tech
                          </p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div class="ct_story_slide_card">
                      <div class="ct_story_user_img">
                        <img src="assets/img/story_img_user.png" alt="" />
                      </div>
                      <div>
                        <div class="ct_orange_text mb-3">
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                        </div>
                        <h3 class="ct_fs_20 mb-3">
                          Climbing Higher with Every Project
                        </h3>
                        <p class="ct_fS_18" style={{ maxWidth: "351px" }}>
                          NuStar gave me access to exclusive projects that truly
                          challenged and grew my expertise. Today, I lead
                          innovative product initiatives and mentor upcoming
                          tech talents.
                        </p>
                        <div class="mt-5">
                          <h4 class="ct_fs_20">Chloe Adams</h4>
                          <p class="ct_fs_18">
                            Product Director at Zenith Tech
                          </p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
        </section>

        <section class=" ct_px_40 pt-0 ct_mt_100">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div
                class="col-xxl-4  col-xl-5 col-lg-6 mb-4 mb-lg-0 "
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                <div class="ct_about_img">
                  <img
                    src="assets/img/faq_896.png"
                    class="ct_img_h_617"
                    alt=""
                  />
                </div>
              </div>
              <div
                class="col-xxl-7 col-xl-7 col-lg-6 mb-4 mb-lg-0 ps-lg-5"
                data-aos="fade-left"
                data-aos-duration="1000"
              >
                <div class="ct_about_cnt">
                  <h2 class="mb-4 ct_fs_32 mb-5 ct_darkblue_text ">
                    Frequently asked questions
                  </h2>

                  <div class="ct_faq_question_main ct_faq_question_yellow_plus">
                    <div class="accordion" id="faq_accordionExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="faq_one">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsefaq_one"
                            aria-expanded="false"
                            aria-controls="collapsefaq_one"
                          >
                            What types of events does NUVIO offer?
                          </button>
                        </h2>
                        <div
                          id="collapsefaq_one"
                          class="accordion-collapse collapse"
                          aria-labelledby="faq_one"
                          data-bs-parent="#faq_accordionExample"
                        >
                          <div class="accordion-body">
                            <p class="ct_fs_20 mb-2 ct_line_h_30">
                              NUVIO offers three main types of events:
                            </p>
                            <ul style={{ listStyle: "disc" }} className="ps-5">
                              <li className="ct_fs_20">
                                <strong>Webinars:</strong> Monthly live online
                                sessions led by top coaches on growth, clarity,
                                leadership, and skills development.
                              </li>
                              <li className="mt-1 ct_fs_20">
                                <strong>Workshops:</strong> Hands-on interactive
                                sessions designed to teach practical skills,
                                techniques, and strategies you can apply
                                immediately.
                              </li>
                              <li className="mt-1 ct_fs_20">
                                <strong>Bootcamps:</strong> Immersive multi-day
                                programs that combine learning, coaching, and
                                real-world application to accelerate personal
                                and professional growth.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="faqtwo">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsefaq_Two"
                            aria-expanded="true"
                            aria-controls="collapseTwo"
                          >
                            How do I register for a webinar, workshop, or
                            bootcamp?
                          </button>
                        </h2>
                        <div
                          id="collapsefaq_Two"
                          class="accordion-collapse collapse "
                          aria-labelledby="faqtwo"
                          data-bs-parent="#faq_accordionExample"
                        >
                          <div class="accordion-body">
                            <p class="ct_fs_20 mb-3 ct_line_h_30">
                              Simply click “Register” or “Get Started” on the
                              event page, create a NUVIO account if you don’t
                              have one, and secure your spot.
                            </p>
                            {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                              If you’re doing something new, on a bigger
                              scale, or need more flexibility, then Builder
                              Studio is for you. Prices vary depending on the
                              features you need but again, you’ll know exactly
                              what you’re paying upfront.
                            </p> */}
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="faqthree">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsefaq_Three"
                            aria-expanded="false"
                            aria-controls="collapsefaq_Three"
                          >
                            Do I need prior experience to participate?
                          </button>
                        </h2>
                        <div
                          id="collapsefaq_Three"
                          class="accordion-collapse collapse"
                          aria-labelledby="faqthree"
                          data-bs-parent="#faq_accordionExample"
                        >
                          <div class="accordion-body">
                            <p class="ct_fs_20 mb-3 ct_line_h_30">
                              No. Our events are designed for all levels from
                              beginners to experienced professionals, so
                              everyone can gain value and actionable insights.
                            </p>
                            {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                              If you’re doing something new, on a bigger
                              scale, or need more flexibility, then Builder
                              Studio is for you. Prices vary depending on the
                              features you need but again, you’ll know exactly
                              what you’re paying upfront.
                            </p> */}
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="faqFour">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsefaq_Four"
                            aria-expanded="false"
                            aria-controls="collapsefaq_Four"
                          >
                            Will sessions be interactive?
                          </button>
                        </h2>
                        <div
                          id="collapsefaq_Four"
                          class="accordion-collapse collapse"
                          aria-labelledby="faqFour"
                          data-bs-parent="#faq_accordionExample"
                        >
                          <div class="accordion-body">
                            <p class="ct_fs_20 mb-3 ct_line_h_30">
                              Yes! Webinars include live Q&As, workshops feature
                              hands-on exercises, and bootcamps provide
                              coaching, group activities, and networking
                              opportunities.
                            </p>
                            {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                              If you’re doing something new, on a bigger
                              scale, or need more flexibility, then Builder
                              Studio is for you. Prices vary depending on the
                              features you need but again, you’ll know exactly
                              what you’re paying upfront.
                            </p> */}
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="faqFive">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsefaq_Five"
                            aria-expanded="false"
                            aria-controls="collapsefaq_Five"
                          >
                            Can I access recordings or resources after an event?
                          </button>
                        </h2>
                        <div
                          id="collapsefaq_Five"
                          class="accordion-collapse collapse"
                          aria-labelledby="faqFive"
                          data-bs-parent="#faq_accordionExample"
                        >
                          <div class="accordion-body">
                            <p class="ct_fs_20 mb-3 ct_line_h_30">
                              Absolutely. All webinars, workshops, and bootcamps
                              are recorded. Participants receive access to
                              replays, slides, and supporting resources in their
                              dashboard.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="faqSix">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsefaq_Six"
                            aria-expanded="false"
                            aria-controls="collapsefaq_Six"
                          >
                            Can I interact with coaches or speakers during
                            events?
                          </button>
                        </h2>
                        <div
                          id="collapsefaq_Six"
                          class="accordion-collapse collapse"
                          aria-labelledby="faqSix"
                          data-bs-parent="#faq_accordionExample"
                        >
                          <div class="accordion-body">
                            <p class="ct_fs_20 mb-3 ct_line_h_30">
                              Yes! Webinars, workshops, and bootcamps are
                              designed to encourage engagement, including Q&As,
                              breakout sessions, and networking opportunities
                              with coaches and fellow participants.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="faqSeven">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsefaq_Seven"
                            aria-expanded="false"
                            aria-controls="collapsefaq_Seven"
                          >
                            How will NUVIO events help my freelance or project
                            work?
                          </button>
                        </h2>
                        <div
                          id="collapsefaq_Seven"
                          class="accordion-collapse collapse"
                          aria-labelledby="faqSeven"
                          data-bs-parent="#faq_accordionExample"
                        >
                          <div class="accordion-body">
                            <p class="ct_fs_20 mb-3 ct_line_h_30">
                              Events are structured to provide actionable
                              insights, practical skills, and networking
                              opportunities that directly support your projects,
                              freelance growth, and career development.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="faqEight">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsefaq_Eight"
                            aria-expanded="false"
                            aria-controls="collapsefaq_Eight"
                          >
                            How can I maximize my learning and growth from
                            events?
                          </button>
                        </h2>
                        <div
                          id="collapsefaq_Eight"
                          class="accordion-collapse collapse"
                          aria-labelledby="faqEight"
                          data-bs-parent="#faq_accordionExample"
                        >
                          <div class="accordion-body">
                            <p class="ct_fs_20 mb-3 ct_line_h_30">
                              Participate actively, ask questions, network with
                              other attendees, take notes, and apply the
                              strategies and tools you learn immediately.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          class="ct_looking_for_work_bg ct_looking_for_work_bg_left ct_orange_bg ct_mt_100 "
          data-aos="fade-right"
          data-aos-duration="1000"
          style={{ marginBottom: "150px" }}
        >
          <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
            <div class="text-white">
              <h4 class="ct_fs_36 mb-4" style={{ maxWidth: "640px" }}>
                Ready to Learn Something That Actually Moves the Needle?
              </h4>
              <p class="mb-0 ct_fs_18" style={{ maxWidth: "619px" }}>
                Join a live session, get real-time support, and walk away with
                tools you can apply today- not someday.{" "}
              </p>
            </div>
            <div class="ct_flex_shrink_0">
              <a
                class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                onClick={(e) => {
                  e.preventDefault();
                  navigate(enterPrisesPaths?.ExploreService);
                }}
              >
                Explore Our Services
              </a>
            </div>
          </div>
        </section>

        {isSpotModal && (
          <ClaimYourSpot
            isOpen={isSpotModal}
            id={id}
            setClose={setIsSpotModal}
            isSuccessModal={isSuccessModal}
            setIsSuccessModal={setIsSuccessModal}
          />
        )}
      </MenuLayout>

      {isPurchse && bootCampId && (
        <BootcampPurchaseModal
          onClose={() => setIsPurchase(false)}
          ID={bootCampId}
          handleClose={() => {
            setIsPurchase(false);
            dispath(fetchBootCamps());
            setIsPaymentShow(true);
          }}
        />
      )}
      {isPaymentShow && (
        <PaymentModal onClose={() => setIsPaymentShow(false)} />
      )}
      {isWaitList && (
        <WaittingListBootCamp
          onClose={() => setIsWaitList(false)}
          ID={bootCampId}
          handleClose={() => {
            setIsWaitList(false);
            dispath(fetchBootCamps());
          }}
        />
      )}
    </div>
  );
};

export default WebinarData;
